/**
 * Outlook Login Fragment
 * Hands the established session to the Outlook task pane, which then closes
 * the dialog this page runs in.
 */

let initialized = false;

// ============================================================================
// Outlook Handlers
// ============================================================================

const OutlookLoginHandlers = {
    /**
     * The session details ride on the element rather than being templated
     * into a script. Office.js is loaded by the page itself, so this only
     * runs where that tag is present.
     */
    handOff(element) {
        if (!window.Office || !Office.onReady) return;
        Office.onReady(function () {
            Office.context.ui.messageParent(JSON.stringify({
                type: 'connected',
                session: element.dataset.session,
                username: element.dataset.username,
            }));
        });
    },
};

// ============================================================================
// Initialization
// ============================================================================

export function initOutlookLogin() {
    if (initialized) return;
    initialized = true;

    document
        .querySelectorAll('[data-outlook-handoff]')
        .forEach(OutlookLoginHandlers.handOff);
}
